/**
 * Delete-template confirmation text (QA batch 12, 2026-10-21). Deleting a
 * template keeps the subtasks it added to work items; they are only unlinked.
 * `workItems` undefined = usage not known (loading / older server).
 */
export const templateDeleteText = (workItems?: number | null): string => {
  if (workItems == null || workItems < 0) {
    return "Do you want to permanently delete this template?";
  }
  if (workItems === 0) {
    return "This template isn't used on any work items. Do you want to permanently delete it?";
  }
  const items = workItems === 1 ? "1 work item" : `${workItems} work items`;
  return `Used on ${items}. Their subtasks from this template stay on the work items; they just won't be linked to this template any more. Do you want to permanently delete it?`;
};
